import axios from 'axios'

export default {
  namespaced: true,
  state: {
    guest_periodReport__show: {},
  },
  mutations: {
    SET_guest_periodReport__show(state, payload) {
      state.guest_periodReport__show = payload
    },
  },
  getters: {
    guest_periodReport__show: (state) => {
      if (state.guest_periodReport__show !== null) {
        while (typeof state.guest_periodReport__show.data === 'string') {
          state.guest_periodReport__show.data = JSON.parse(state.guest_periodReport__show.data)
        }
        while (typeof state.guest_periodReport__show.additional_data === 'string') {
          state.guest_periodReport__show.additional_data = JSON.parse(
            state.guest_periodReport__show.additional_data,
          )
        }
      }

      return state.guest_periodReport__show
    },
  },
  actions: {
    ON_guest_periodReport__show({ commit, rootState }, hash) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/guest/period-report/' + hash,
          method: 'GET',
        })
          .then((resp) => {
            console.log(resp.data)
            commit('SET_guest_periodReport__show', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    ON_guest_periodReport__sign({ rootState }, { data, hash }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/guest/period-report/sign/' + hash,
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
